import { Navigate, Outlet } from 'libs/router'

import { useAuth, useUserRoles } from 'shared/hooks'
import { Spinner } from 'shared/atoms'

export const PreventUser = () => {
	const { auth } = useAuth()
	const { isUser } = useUserRoles()

	if (!auth?.user) return <Spinner />

	return isUser ? <Navigate to="/" replace /> : <Outlet />
}
